import { Box } from "@ui/box/Box";
import { IconAvatar } from "src/assets/icon_avatar";

export const Avatar = (props: { size?: string }) => {
	const size = props.size ?? "35px";
	return (
		<Box
			sx={{
				// backgroundColor: generatePastelColor(),
				width: size,
				height: size,
				minWidth: size,
				maxWidth: size,
				minHeight: size,
				maxHeight: size,
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				borderRadius: "50%",
				backgroundColor: "#e5e7eb",
			}}>
			<IconAvatar size={parseInt(size, 10) / 1.5} />
		</Box>
	);
};

// function generatePastelColor(): string {
// 	const randomChannel = (): number => Math.floor(Math.random() * 128 + 127); // От 127 до 255
// 	// Генерация каналов R, G, B
// 	const r = randomChannel();
// 	const g = randomChannel();
// 	const b = randomChannel();

// 	// Преобразуем в HEX
// 	const toHex = (value: number): string =>
// 		value.toString(16).padStart(2, "0");

// 	// Возвращаем цвет в формате HEX
// 	return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
// }
